


























































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { IFieldInfoListItem } from '@/types/component';
import ShowImg from '@/components/show-img/index.vue';
import { orderHandLiftExamine } from '@/api/exception-management/index';
@Component({
  name: 'HandDetail',
  components: { ShowImg }
})
export default class HandDetail extends Vue {
  // 是否审核
  @Prop({ type: Boolean, default: false })
  isReview!: boolean;
  // 数据
  @Prop({ type: Object, default: {} })
  formData!: Record<string, any>;
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  reviewDescription = '';
  formFields = [
    {
      prop: 'parkName',
      label: '车场名称'
    },
    {
      prop: 'plate',
      label: '参考车牌号'
    },
    {
      prop: 'direction',
      label: '进出场类型'
    },
    {
      prop: 'channelName',
      label: '通道名称'
    },
    {
      prop: 'liftTime',
      label: '抬杆时间'
    },
    {
      prop: 'liftCauseName',
      label: '抬杆原因'
    },
    {
      prop: 'liftTypeName',
      label: '抬杆方式'
    },
    {
      prop: 'operater',
      label: '操作人'
    },
    {
      prop: 'orderId',
      label: '停车订单号'
    },
    {
      prop: 'descrpition',
      label: '备注'
    }
  ];
  formReviewFields = [
    {
      prop: 'reviewStatusName',
      label: '审核状态'
    },
    {
      prop: 'reviewTime',
      label: '审核时间'
    },
    {
      prop: 'reviewDescription',
      label: '审核意见'
    },
    {
      prop: 'reviewer',
      label: '审核人'
    }
  ];
  loadingFlag: boolean = false;
  //
  onSubmit() {
    if (this.isReview) {
      const json = {
        id: this.formData.pkLiftId,
        parkId: this.formData.parkId,
        reviewDescription: this.reviewDescription,
        reviewStatus: '01',
        userId: this.formData.userId,
        orderId: this.formData.orderId
      };
      this.reviewItem(json);
    } else {
      this.$emit('cancel');
    }
  }
  //
  cacnelItem() {
    if (this.isReview) {
      const json = {
        id: this.formData.pkLiftId,
        parkId: this.formData.parkId,
        reviewDescription: this.reviewDescription,
        reviewStatus: '00',
        userId: this.formData.userId,
        orderId: this.formData.orderId
      };
      this.reviewItem(json);
    } else {
      this.$emit('cancel');
    }
  }
  onCancel() {
    this.$emit('cancel');
  }
  //审核
  async reviewItem(json: {
    id: any;
    parkId: any;
    reviewDescription: string;
    reviewStatus: string;
    userId: any;
    orderId: any;
  }) {
    try {
      if (this.loadingFlag) return;
      this.loadingFlag = true;
      await orderHandLiftExamine(json);
      this.$message.success('意见提交成功');
      this.$emit('create');
    } catch (e) {
      this.$message.error(e.msg || '系统繁忙请稍后再试');
    } finally {
      this.loadingFlag = false;
    }
  }
}
